import i18n from '@/i18n/i18n'

const { t } = i18n.global

export const SALES_CHANNEL_TYPE = {
  FORWARD_SALE: 1,
  DIRECT_FORWARD: 3,
  DIRECT_CASH: 4,
  FIBABANK: 5,
  FORWARD_SALE_WITH_RETAILER_DELAYED: 6,
  DIRECT_CASH_TO_RETAILER: 7,
  ROMANIA_FORWARD_SALE: 8,
  ROMANIA_FORWARD_SALE_WITH_RETAILER_DELAYED: 9,
  ROMANIA_PRIVATE_INDIVIDUAL: 10,
  VIRTUAL_POS: 11,
  V4: 100
}

export const SALES_CHANNEL_TYPE_MAP = {
  1: t('constants.sales_channels.tarfin_forward'),
  3: t('constants.sales_channels.tarfin_direct_forward'),
  4: t('constants.sales_channels.tarfin_direct_cash'),
  5: 'Fibabanka',
  6: t('constants.sales_channels.forward_sale_with_retailer_delayed'),
  7: t('constants.sales_channels.direct_cash_to_retailer'),
  8: t('constants.sales_channels.romania_forward_sale'),
  9: t('constants.sales_channels.romania_forward_sale_with_retailer_delayed'),
  10: t('constants.sales_channels.romania_private_individual'),
  11: t('constants.sales_channels.tarfin_virtual_pos'),
  100: 'V4'
}

export const SALES_CHANNEL_TYPE_CLASS_MAP = {
  1: 'primary-lighten',
  3: 'info-lighten',
  4: 'danger-lighten',
  5: 'success-lighten',
  6: 'dark-lighten',
  7: 'purple-lighten',
  8: 'primary-lighten',
  9: 'info-lighten',
  10: 'danger-lighten',
  11: 'danger-lighten',
  100: 'indigo-lighten'
}

export const SALES_CHANNEL_SUMMARY_EVENT_NAME_MAP = {
  [SALES_CHANNEL_TYPE.DIRECT_CASH]: 'summary_page_direct_cash_application_shortcut_click',
  [SALES_CHANNEL_TYPE.FORWARD_SALE]: 'summary_page_forward_application_shortcut_click',
  [SALES_CHANNEL_TYPE.DIRECT_FORWARD]: 'summary_page_direct_forward_application_shortcut_click',
  [SALES_CHANNEL_TYPE.ROMANIA_FORWARD_SALE]: 'summary_page_romania_forward_application_shortcut_click',
  [SALES_CHANNEL_TYPE.ROMANIA_PRIVATE_INDIVIDUAL]: 'summary_page_romania_private_individual_application_shortcut_click'
}

export const SALES_CHANNEL_APPLICATION_EVENT_NAME_MAP = {
  [SALES_CHANNEL_TYPE.DIRECT_CASH]: 'application_page_direct_cash_application_click',
  [SALES_CHANNEL_TYPE.FORWARD_SALE]: 'application_page_forward_application_click',
  [SALES_CHANNEL_TYPE.DIRECT_FORWARD]: 'application_page_direct_forward_application_click',
  [SALES_CHANNEL_TYPE.ROMANIA_FORWARD_SALE]: 'application_page_romania_forward_application_click',
  [SALES_CHANNEL_TYPE.ROMANIA_PRIVATE_INDIVIDUAL]: 'application_page_romania_private_individual_application_click'
}

export const isRomaniaSalesChannel = salesChannelId => {
  return [
    SALES_CHANNEL_TYPE.ROMANIA_FORWARD_SALE,
    SALES_CHANNEL_TYPE.ROMANIA_FORWARD_SALE_WITH_RETAILER_DELAYED,
    SALES_CHANNEL_TYPE.ROMANIA_PRIVATE_INDIVIDUAL
  ].includes(salesChannelId)
}


export const isVirtualPosSalesChannel = salesChannelId => salesChannelId === SALES_CHANNEL_TYPE.VIRTUAL_POS

export const isRomaniaSRL = salesChannelId => {
  return [
    SALES_CHANNEL_TYPE.ROMANIA_FORWARD_SALE,
    SALES_CHANNEL_TYPE.ROMANIA_FORWARD_SALE_WITH_RETAILER_DELAYED
  ].includes(salesChannelId)
}

export const isRomaniaIFN = salesChannelId => {
  return [SALES_CHANNEL_TYPE.ROMANIA_PRIVATE_INDIVIDUAL].includes(salesChannelId)
}

export const DEFAULT_SALES_CHANNELS_ROMANIA = [
  {
    id: SALES_CHANNEL_TYPE.ROMANIA_FORWARD_SALE,
    parent_id: null,
    name: t('constants.sales_channels.romania_forward_sale'),
    label: t('constants.sales_channels.romania_forward_sale'),
    supplier_type: 0,
    payment_type: 1,
    created_at: '2021-12-09T10:57:53.000000Z',
    updated_at: '2021-12-09T10:57:53.000000Z',
    deleted_at: null
  },
  {
    id: SALES_CHANNEL_TYPE.ROMANIA_FORWARD_SALE_WITH_RETAILER_DELAYED,
    parent_id: 8,
    name: t('constants.sales_channels.romania_forward_sale_with_retailer_delayed'),
    label: t('constants.sales_channels.romania_forward_sale_with_retailer_delayed'),
    supplier_type: 0,
    payment_type: 1,
    created_at: '2022-08-17T07:08:34.000000Z',
    updated_at: '2022-08-17T07:08:34.000000Z',
    deleted_at: null
  },
  {
    id: SALES_CHANNEL_TYPE.ROMANIA_PRIVATE_INDIVIDUAL,
    parent_id: null,
    name: t('constants.sales_channels.romania_private_individual'),
    label: t('constants.sales_channels.romania_private_individual'),
    supplier_type: 0,
    payment_type: 1,
    created_at: '2023-03-03T14:28:34.000000Z',
    updated_at: '2023-03-03T14:28:34.000000Z',
    deleted_at: null
  }
]

export const DEFAULT_SALES_CHANNELS_TR = [
  {
    created_at: '2020-02-04T09:27:10.000000Z',
    deleted_at: null,
    id: SALES_CHANNEL_TYPE.FORWARD_SALE_WITH_RETAILER_DELAYED,
    label: t('views.admin.products.sales_channels_opportunities'),
    name: t('views.retailer.applications.edit.future_payment'),
    parent_id: 1,
    payment_type: 1,
    supplier_type: 0,
    updated_at: '2020-02-04T09:27:10.000000Z'
  },
  {
    created_at: null,
    deleted_at: null,
    id: SALES_CHANNEL_TYPE.FORWARD_SALE,
    label: t('views.admin.products.sales_channels_deferred_label'),
    name: t('constants.sales_channels.tarfin_forward'),
    parent_id: null,
    payment_type: 1,
    supplier_type: 0,
    updated_at: null
  },
  {
    created_at: null,
    deleted_at: null,
    id: SALES_CHANNEL_TYPE.FIBABANK,
    label: '',
    name: t('constants.sales_channels.fibabank'),
    parent_id: null,
    payment_type: 1,
    supplier_type: 0,
    updated_at: null
  }
]
